import React from 'react';
import { FaTruck, FaClock, FaShieldAlt, FaRoute } from 'react-icons/fa';

const stats = [
  { icon: <FaTruck />, value: '48', label: 'States Served' },
  { icon: <FaClock />, value: '24/7', label: 'Dispatch Support' },
  { icon: <FaShieldAlt />, value: '20+', label: 'Years of Service' },
  { icon: <FaRoute />, value: '100%', label: 'On-Time Focus' },
];

const AboutUs = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Text Column */}
          <div className="col-lg-6" data-aos="fade-right">
            <span className="about__label">Who We Are</span>
            <h2 className="about__title">A Trusted Name in American Logistics</h2>
            <p className="about__text">
              For over two decades, C.H.I. Logistics has been a trusted leader in the
              transportation industry. We specialize in delivering reliable, efficient, and
              tailored freight solutions to meet the diverse needs of our clients nationwide.
            </p>
            <p className="about__text">
              Equipped with a fleet of state-of-the-art trucks and cutting-edge technology,
              we guarantee timely deliveries every time. From OTR transportation and dedicated
              logistics to expedited shipping and round-the-clock dispatch — reliability and
              customer satisfaction are our promise.
            </p>
          </div>

          {/* Image Column */}
          <div className="col-lg-6" data-aos="fade-left">
            <div className="about__image-wrap">
              <img src="/image3.png" alt="C.H.I. Logistics Fleet" className="about__image" />
            </div>
          </div>
        </div>

        {/* Stats Row */}
        <div className="row g-4 about__stats">
          {stats.map((stat, i) => (
            <div className="col-6 col-md-3" key={i} data-aos="fade-up" data-aos-delay={i * 80}>
              <div className="stat-card">
                <div className="stat-card__icon">{stat.icon}</div>
                <div className="stat-card__value">{stat.value}</div>
                <div className="stat-card__label">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
